import { prop, path } from 'ramda';

import { FEATURE_NAME as $ } from './consts';

export const getChapters = prop($);
export const getChapter = (name) => path([$, name]);
